import SEOPage from "./SEOPage";

export default function IUITreatmentAmbala() {
  return (
    <SEOPage
      title="IUI Treatment in Ambala | Amaanat IVF Clinic"
      description="Affordable IUI Treatment in Ambala performed by experienced fertility specialists using advanced fertility techniques."
      canonical="https://amaanativf.com/iui-treatment-in-ambala"
      heading="IUI Treatment in Ambala"
      focusKeyword="IUI Treatment in Ambala"
    />
  );
}